<template>
  <div
    v-if="isGuest"
    class="my-5 alert text-white w-75 mx-auto"
    style="background-color: var(--gdep_color__secondary-dark)"
    role="alert"
  >
    <h4 class="alert-heading text-center text-uppercase">
      Sauvegardez vos résultats
    </h4>
    <p class="text-center">
      Pour retrouver plus facilement vos résultats, vous pouvez les enregistrer
      en créeant un compte. <br />
      La création d'un compte vous permet d'ajouter également des notes
      peronnelles.
    </p>
    <p class="mb-0 text-center">
      <a :href="registerUrl" class="text-white text-700"> Créer un compte </a>
      <a :href="loginUrl" class="text-white text-700"> Se Connecter </a>
    </p>
  </div>
</template>

<script>
import AuthMixin from '../mixins/AuthMixin'
export default {
  mixins: [AuthMixin],
  computed: {
    isGuest() {
      return this.$page.props.is_guest
    },
  },
}
</script>
